import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useSettingsStore = defineStore("settings", {
  state: () => {
    return {
      deliveries: [],
      payments: [],
      credits: {
        active: true,
        birthday: {
          active: false,
          addAt: 0, // 0 = 生日當天，1 = 生日當月1號
          content: { money: null, validDays: null, unlimited: false },
        },
        new_member: {
          active: false,
          content: { money: null, validDays: null, unlimited: false },
        },
        condition: { type: "none", orderMoney: null, limit: "none", limitValue: null },
        allow_customer_edit: false,
        exclude_no_discount_products: false,
      },
      points: {
        active: true,
        validDays: { unlimited: true, month: 1, day: 31 },
        earn: { active: false, money: null, points: null },
        redeemCash: { active: false, points: null, cash: null },
        condition: { type: "none", orderMoney: null, limit: "none", limitValue: null },
        exclude_no_discount_products: false,
        instructions: null,
      },
      logos: {
        pc: { src: null, width: "", height: "" },
        mobile: { src: null, width: "", height: "" },
        fav: { src: null, width: "", height: "" },
      },
      styles: {
        main_color: "#a88661",
      },
      checkout: {
        rules: null,
        require_agree_rules: false,
      },
    };
  },
});

export const storeSettings = useSettingsStore(pinia);
